package com.milta.core.auth

import com.milta.feature.auth.data.remote.dto.SubscriptionAccessScope
import com.milta.feature.auth.domain.entity.UserRole

sealed class SessionEvent {
    object LoggedIn : SessionEvent()
    object LoggedOut : SessionEvent()
    object SessionExpired : SessionEvent()
    data class SubscriptionExpired(val role: UserRole, val scope: SubscriptionAccessScope) : SessionEvent()
}
